/**
 * @description Generic component to show errors
 * <Error
 type="error type to show"
 text="Text to show to the user related to the error"
 button={{
            text: 'Text to show on the error button',
            click: () => { console.log('Action to do on the error button'); },
            color: 'bubbleGum',
            outline: false,
            transparent: false,
        }}
 icon={iconImport}
 * />
 * @author Camilo Ramirez
 */

import React from 'react';
import PropTypes from 'prop-types';
import Container from './styles/ErrorStyled';
import Button from '../Button';

const Error = ({ type, text, icon, button, noButton }) => (
  <Container>
    <img src={icon} alt="Icono Error" />
    <p>
      <span>{type}</span>
    </p>
    <span>{text}</span>
    {!noButton && (
      <Button
        click={button.click}
        color={button.color}
        outline={button.outline}
        transparent={button.transparent}
        margin={button.margin ? button.margin : '30px auto 0 auto'}
        maxWidth={button.maxWidth ? button.maxWidth : 'fit-content'}
      >
        {button.text}
      </Button>
    )}
  </Container>
);

Error.propTypes = {
  type: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  icon: PropTypes.string.isRequired,
  button: PropTypes.instanceOf(Object),
  noButton: PropTypes.bool,
};

Error.defaultProps = {
  type: 'Datos',
  button: {
    color: 'purple',
    ouline: true,
    transparent: false,
    text: 'Reintentar',
  },
  noButton: false,
};

export default Error;
